import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'role'})
export class RolePipe implements PipeTransform {
  transform(value: string): string {
    return value.charAt(0);
  }
}
